export const getSyncStatusMetadata = (
  syncStatus?: MergeSyncStatus,
): ValueOf<typeof syncStatusMetadata> | undefined => {
  if (!syncStatus) {
    return {
      syncStatusTitle: 'Unavailable',
      syncStatusTooltip: '',
    };
  }
  return syncStatusMetadata[syncStatus];
};

const syncStatusMetadata: {
  [status in MergeSyncStatus]: { syncStatusTitle: string; syncStatusTooltip: string };
} = {
  DISABLED: {
    syncStatusTitle: 'Disabled',
    syncStatusTooltip: 'The integration has been disabled',
  },
  DONE: {
    syncStatusTitle: 'Done',
    syncStatusTooltip:
      'We successfully fetched data from the HRIS and imported it into the directory',
  },
  FAILED: {
    syncStatusTitle: 'Failed',
    syncStatusTooltip: 'We failed to fetch data from the HRIS',
  },
  PAUSED: {
    syncStatusTitle: 'Paused',
    syncStatusTooltip: 'The integration is paused and will not fetch new data',
  },
  SYNCING: {
    syncStatusTitle: 'Syncing',
    syncStatusTooltip: 'We are currently fetching data from the HRIS',
  },
  // Admin only statuses prefixed with IMPORT
  IMPORT_FAILED: {
    syncStatusTitle: 'Import failed (admin only)',
    syncStatusTooltip:
      'We successfully fetched data from the HRIS but could not import it into the directory',
  },
  IMPORT_PAUSED: {
    syncStatusTitle: 'Import paused (admin only)',
    syncStatusTooltip: "We've paused importing data from Merge.",
  },
};
